import { Box, Heading, Text } from '@ksyos/design-system';
import type { ISelectTileProps } from './DropDownTileSelectContainer';

interface IDropDownTileSelectProps {
    onClick: (id: string) => void;
    tiles: ISelectTileProps[];
}

export function DropDownTileSelect(props: IDropDownTileSelectProps) {
    return (
        <Box
            className="automation-tile-select"
            display="grid"
            gap={4}
            gridTemplateColumns="repeat(auto-fill, minmax(200px, 1fr))"
        >
            {props.tiles.map((tile) => (
                <SelectTile
                    {...tile}
                    key={tile.id}
                    onClick={() => props.onClick(tile.id)}
                />
            ))}
        </Box>
    );
}

function SelectTile(props: ISelectTileProps & { onClick: (id: string) => void }) {
    return (
        <Box
            as="a"
            onClick={() => props.onClick(props.id)}
            p={4}
            role="button"
            sx={{
                cursor: 'pointer',
                transition: 'all 0.2s ease-out',
                'box-shadow': 'inset 0 0 0 1px #dbd5d0',
                '&:hover': { 'box-shadow': 'inset 0 0 0 1px #50463f' },
            }}
            tabIndex={0}
        >
            <Heading
                mb={2}
                size="small"
            >
                {props.title}
            </Heading>
            {props.bodyText && <Text size="sm">{props.bodyText}</Text>}
        </Box>
    );
}
